import { HttpClient } from "@angular/common/http";
import { computed, inject, Injectable, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { ApiResponse, Faq } from "app/@core/types";
import { environment } from "environments/environment";
import { map, of } from "rxjs";
import { unwrapResponse } from "../utils/api-utils";

@Injectable({ providedIn: "root" })
export class FaqService {
  private http = inject(HttpClient);
  baseUrl: string = environment.baseUrl + "courses/faq/";

  readonly activeCourseId = signal<number | null>(null);

  readonly faqResource = rxResource({
    request: () => this.activeCourseId(),

    loader: ({ request: courseId }) => {
      if (!courseId) return of(null);
      return this.http
        .get<ApiResponse>(`${this.baseUrl}${courseId}/all`)
        .pipe(map(unwrapResponse<Faq[]>));
    },
  });

  readonly faqs = computed(() => this.faqResource.value() ?? []);
  readonly faqsCount = computed(() => this.faqs().length);

  getLessonFaq(lessonId: number): Faq[] {
    return this.faqs().filter((faq: Faq) => (faq.lesson_id = lessonId));
  }

  loadCourseFaq(courseId: number) {
    this.activeCourseId.set(courseId);
  }
}
